import {
  getEligiblePlatformsForCampaign,
  platformKeysMatch,
} from "../../../features/measurable-kpi/utils/measurableKpiRules";

const STATISTICS_BREAKDOWNS = ["maximum", "daily"];

const filterPlatformBranch = (branch = {}, eligiblePlatforms = []) => {
  if (!branch || typeof branch !== "object") {
    return {};
  }

  const filtered = {};
  Object.entries(branch).forEach(([platform, platformData]) => {
    if (
      eligiblePlatforms.some((eligiblePlatform) =>
        platformKeysMatch(eligiblePlatform, platform)
      )
    ) {
      filtered[platform] = platformData;
    }
  });
  return filtered;
};

const filterUnifiedCampaignStatistics = (
  unifiedCampaign,
  eligiblePlatforms
) => {
  if (!unifiedCampaign || !eligiblePlatforms.length) {
    return null;
  }

  const eligibleRawPlatforms = (unifiedCampaign.platforms || []).filter(
    (platform) =>
      eligiblePlatforms.some((eligiblePlatform) =>
        platformKeysMatch(eligiblePlatform, platform)
      )
  );

  if (!eligibleRawPlatforms.length) {
    return null;
  }

  const filteredLevels = {};
  const levels = unifiedCampaign.levels || {};

  Object.entries(levels).forEach(([levelKey, levelValue]) => {
    if (!levelValue || typeof levelValue !== "object") {
      return;
    }

    filteredLevels[levelKey] = {};

    STATISTICS_BREAKDOWNS.forEach((breakdownKey) => {
      if (!levelValue[breakdownKey]) {
        return;
      }
      filteredLevels[levelKey][breakdownKey] = filterPlatformBranch(
        levelValue[breakdownKey],
        eligibleRawPlatforms
      );
    });
  });

  return {
    ...unifiedCampaign,
    platforms: eligibleRawPlatforms,
    levels: filteredLevels,
  };
};

const filterCampaignRecord = (campaign, eligiblePlatforms) => {
  if (!campaign || !eligiblePlatforms.length) {
    return null;
  }

  return {
    ...campaign,
    platforms: eligiblePlatforms,
  };
};

export const filterGlobalReportByMeasurableKpi = ({
  campaigns = {},
  statistics = {},
  previousPeriodStatistics = {},
  measurableKpiKey = null,
}) => {
  if (!measurableKpiKey) {
    return {
      campaigns,
      statistics,
      previousPeriodStatistics,
    };
  }

  const filteredCampaigns = {};
  const filteredStatisticsCampaigns = {};
  const filteredPreviousStatisticsCampaigns = {};

  Object.keys(campaigns).forEach((campaignID) => {
    const campaign = campaigns[campaignID];

    const eligiblePlatforms = getEligiblePlatformsForCampaign(
      campaign,
      measurableKpiKey
    );

    if (!eligiblePlatforms.length) {
      return;
    }

    const filteredCampaign = filterCampaignRecord(campaign, eligiblePlatforms);
    if (filteredCampaign) {
      filteredCampaigns[campaignID] = filteredCampaign;
    }

    const unifiedCampaign = statistics?.campaigns?.[campaignID];
    const filteredUnified = filterUnifiedCampaignStatistics(
      unifiedCampaign,
      eligiblePlatforms
    );
    if (filteredUnified) {
      filteredStatisticsCampaigns[campaignID] = filteredUnified;
    }

    const previousUnified = previousPeriodStatistics?.campaigns?.[campaignID];
    const filteredPreviousUnified = filterUnifiedCampaignStatistics(
      previousUnified,
      eligiblePlatforms
    );
    if (filteredPreviousUnified) {
      filteredPreviousStatisticsCampaigns[campaignID] = filteredPreviousUnified;
    }
  });

  return {
    campaigns: filteredCampaigns,
    statistics: {
      ...statistics,
      campaigns: filteredStatisticsCampaigns,
    },
    previousPeriodStatistics: {
      ...previousPeriodStatistics,
      campaigns: filteredPreviousStatisticsCampaigns,
    },
  };
};

export default filterGlobalReportByMeasurableKpi;
